import React from "react";
import { Star, CheckCircle } from "lucide-react";

const TutorProfileCard = ({ tutor }) => {
  return (
    <div className="bg-white rounded-2xl shadow-md p-8 border border-gray-200">
      <div className="flex gap-6">
        <img
          src={tutor.image}
          alt={tutor.name}
          className="w-36 h-36 object-cover rounded-xl"
        />

        <div className="flex-1">
          <h1 className="text-2xl font-semibold text-gray-900">
            {tutor.name}
          </h1>

          <div className="flex items-center gap-2 mt-2">
            <Star
              size={20}
              className="text-yellow-500 fill-yellow-500"
            />
            <span className="font-medium">{tutor.rating}</span>
            <span className="text-gray-600">
              ({tutor.reviews} reviews)
            </span>

            <span className="text-gray-400">•</span>
            <span className="text-gray-700">{tutor.experience}</span>
          </div>

          <div className="flex gap-2 mt-3">
            {tutor.years.map((y, i) => (
              <span
                key={i}
                className="px-4 py-1 bg-gray-100 rounded-full text-sm border border-gray-300"
              >
                {y}
              </span>
            ))}
          </div>

          <div className="mt-6">
            <h2 className="font-semibold text-gray-900 text-lg">
              About
            </h2>
            <p className="text-gray-700 mt-2 leading-relaxed">
              {tutor.description}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TutorProfileCard;